// import PropTypes from 'prop-types';
import styles from './FormPolicyAcceptanceField.module.scss';

const FormPolicyAcceptanceField = ({ label, register, name, errors }) => {
    return (
        <div className={styles['FormPolicyAcceptanceField']}>
            <label
                htmlFor={name}
                className={styles['FormPolicyAcceptanceField__Label']}
            >
                <input
                    id={name}
                    type="checkbox"
                    name={name}
                    {...register}
                    className={styles['FormPolicyAcceptanceField__Checkbox']}
                />
                <div
                    className={styles['FormPolicyAcceptanceField__Policy']}
                    dangerouslySetInnerHTML={{ __html: label }}
                />
            </label>
            {errors && errors[name]?.type === "required" && (
                <span className={styles['FormPolicyAcceptanceField__Error']}>
                    You must accept our policy to be able to submit the form
                </span>
            )}
        </div>
    );
};

FormPolicyAcceptanceField.propTypes = {};

export default FormPolicyAcceptanceField;
